export default{
    svg:`<path d="M12.2344 1.71151L10.8432 0.320313L6.31437 4.83925L1.78557 0.320313L0.394375 1.71151L6.31437 7.63151L12.2344 1.71151Z" fill="fillcolor"/>
    `,
    name:'Caret',
    box:13
}